export const DEFAULT_SIDE_NAV_ICON = 'icons/menu-default.svg';

interface IconSource {
  [key: string]: unknown;
  icon?: unknown;
  viewName?: unknown;
  webRoute?: unknown;
  labelName?: unknown;
}

const ICON_ASSET_BY_FILE = new Map<string, string>([
  ['settings.svg', 'icons/settings.svg'],
  ['building.svg', 'icons/building.svg'],
  ['room.svg', 'icons/room.svg'],
  ['utsav.svg', 'icons/utsav.svg'],
  ['booking.svg', 'icons/booking.svg'],
  ['checkin.svg', 'icons/checkin.svg'],
  ['users.svg', 'icons/users.svg'],
  ['report.svg', 'icons/report.svg'],
  ['search.svg', 'icons/search.svg'],
  ['user-line.svg', 'icons/user-line.svg'],
  ['icons8-compare-48.png', 'icons/icons8-compare-48.png'],
  ['menu-img.svg', 'icons/menu-img.svg'],
  ['changedevotee.svg', 'icons/changeDevotee.svg'],
  ['manual-update.png', 'icons/manual-update.png'],
  ['manual-update.svg', 'icons/manual-update.svg'],
  ['bar-chart-box-line.svg', 'icons/bar-chart-box-line.svg'],
  ['menu-default.svg', DEFAULT_SIDE_NAV_ICON],
]);

const ICON_BY_SEMANTIC_KEY: Readonly<Record<string, string>> = {
  branch_config: 'icons/settings.svg',
  'branch-config': 'icons/settings.svg',
  'branch settings': 'icons/settings.svg',
  configurations: 'icons/settings.svg',
  property_mgmt: 'icons/building.svg',
  properties: 'icons/building.svg',
  room_mgmt: 'icons/room.svg',
  rooms: 'icons/room.svg',
  utsav_setup: 'icons/utsav.svg',
  'utsav-setup': 'icons/utsav.svg',
  'utsav setup': 'icons/utsav.svg',
  bookings: 'icons/booking.svg',
  checkin_checkout: 'icons/checkin.svg',
  'checkin-checkout': 'icons/checkin.svg',
  'check-in / check-out': 'icons/checkin.svg',
  branch_staff: 'icons/users.svg',
  'branch-staff': 'icons/users.svg',
  staff: 'icons/users.svg',
  branch_reports: 'icons/report.svg',
  'branch-reports': 'icons/report.svg',
  reports: 'icons/report.svg',

  'profile-search': 'icons/search.svg',
  'filter-search-main': 'icons/user-line.svg',
  'devotee-compare': 'icons/icons8-compare-48.png',
  'change-primary-devotee': 'icons/menu-img.svg',
  'change-fc': 'icons/changeDevotee.svg',
  'manual-update': 'icons/manual-update.svg',
  'occupancy-statistics': 'icons/bar-chart-box-line.svg',
  'checkin-dashboard': 'icons/bar-chart-box-line.svg',
  'checkin-desk': 'icons/checkin.svg',
  'checkout-desk': 'icons/checkin.svg',
  'booking-search': 'icons/search.svg',
  'guest-history': 'icons/users.svg',
  'my-activity': 'icons/report.svg',
  'my-profile': 'icons/user-line.svg',
  'provision-dashboard': 'icons/bar-chart-box-line.svg',
  'provision-queue': 'icons/booking.svg',
  'manual-provision': 'icons/manual-update.svg',
  'requisition-search': 'icons/search.svg',
  'devotee-utilities': 'icons/settings.svg',
  'utsav-management': 'icons/utsav.svg',
  'accommodation-block': 'icons/room.svg',
  'admin-requisitions': 'icons/booking.svg',
  'operator-management': 'icons/users.svg',
  'room-catalogue': 'icons/building.svg',
  room_catalogue: 'icons/building.svg',
};

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

function localAssetFromBackendPath(value: unknown): string | null {
  const path = text(value).split(/[?#]/, 1)[0].replace(/\\/g, '/');
  const fileName = path.split('/').pop();
  return fileName ? ICON_ASSET_BY_FILE.get(fileName) ?? null : null;
}

/** Resolve only bundled assets; an arbitrary or stale backend path never breaks the menu. */
export function resolveSideNavIcon(view: IconSource): string {
  const suppliedAsset = localAssetFromBackendPath(view.icon);
  if (suppliedAsset) return suppliedAsset;

  for (const value of [view.viewName, view.webRoute, view.labelName]) {
    const asset = ICON_BY_SEMANTIC_KEY[text(value)];
    if (asset) return asset;
  }

  return DEFAULT_SIDE_NAV_ICON;
}
